export default __webpack_public_path__ + "static/media/featured-background.8c1e1c88.png";